var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mx-6"},[_c('v-select',{staticClass:"region-select",class:{'dark': _vm.darkMode},attrs:{"value":_vm.region,"items":[{text: 'All Regions', value: ''}, ..._vm.regions],"solo":""},on:{"input":function($event){return _vm.setRegion($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }